module.exports = __webpack_public_path__ + "static/media/left-arrow.ec4865a8.svg";